// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__Lu6fg","discription":"NotFoundBlock_discription__-GW6-"};